import Request from "@/libraries/request.js";
import Const from "@/const/const.js";

export default {
  BaseURL: "/quotation",
  async get(url = null) {
    const quotationsReply = await Request.getAsync(url);
    let quotations = {};
    if (quotationsReply.data.status) {
      quotations = quotationsReply.data.data;
    }
    return quotations;
  },
  async get_quotation(quoId = null) {
    const url = (quoId != null) ? this.BaseURL + "/" + quoId : this.BaseURL;
    const data = await this.get(url);
    return data;
  }
};



// WEBPACK FOOTER //
// ./src/model/quotation_model.js